module.exports = __webpack_public_path__ + "img/8.96629cba.png";